import React, { useEffect, useState, useMemo } from 'react'
//import { ReactComponent as Logo } from '../images/logo.svg'
//import { ReactComponent as ArrowBack } from '../images/arrow-back.svg'
import { ReactComponent as CrossIcon } from '../images/cross-icon.svg'
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { useLocation, useNavigate } from 'react-router-dom';
import CenteredPopup from './popups/CenteredPopup';
import { useLazyGetPartnersDetailsQuery } from '../lib/services/authApi'

function PageHeader({ back = true, cross = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageError, setPageError] = useState(null);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [partnerDetails, setPartnerDetails] = useState(null);
  const [getPartnersDetails] = useLazyGetPartnersDetailsQuery()
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const scrt = useMemo(() => queryParams.get('secret'), [queryParams])
  const utm_source = useMemo(() => queryParams.get('utm_source'), [queryParams])
  const jwt_token = useMemo(() => queryParams.get('jwt_token'), [queryParams])
  const partner_unique_id = useMemo(() => queryParams.get('partner_unique_id'), [queryParams])
  const partner_uniqueID = useMemo(() => queryParams.get('partner_uniqueID'), [queryParams])
  const handleOpen = () => {
    setIsModalOpen(true);
  }
  const handleClose = () => {
    setIsModalOpen(false);
  }
  const handleErrorOpen = () => {
    setIsErrorModalOpen(true);
  }
  const handleErrorClose = () => {
    setIsErrorModalOpen(false);
  }
  const exitApplication = () => {
    const partnrrdrct = localStorage.getItem('partnerRedirect')
    if (partnrrdrct) {
      window.location.href = partnrrdrct
    } else {
      handleClose()
      navigate('/')
    }
  }
  const modalButtons = [
    { label: 'Yes', className: 'btn-primary-outlined', onClick: exitApplication },
    { label: 'No', onClick: handleClose }
  ]
  const errorModalButtons = [
    { label: 'Close', onClick: handleErrorClose }
  ]

  /*useEffect(() => {
    const handlePopState = (event) => {
      // Trigger the popup when the back button is pressed
      handleOpen();

      // Push the current state again to prevent immediate navigation
      window.history.pushState(null, document.title, window.location.href);
    };

    // Add an initial state to the history stack
    window.history.pushState(null, document.title, window.location.href);

    // Listen for popstate events (back button clicks)
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);*/

  useEffect(() => {
    if (utm_source) {
      localStorage.setItem('utm_source', utm_source)
    }
    else {
      localStorage.setItem('utm_source', "")
    }
    if (jwt_token) localStorage.setItem('jwt', jwt_token)
    if (partner_unique_id) localStorage.setItem('partner_unique_id', partner_unique_id)
    if (partner_uniqueID) localStorage.setItem('partner_uniqueID', partner_uniqueID)
  }, [utm_source, jwt_token, partner_unique_id, partner_uniqueID])

  useEffect(() => {
    const getPartnerDetails = async () => {
      try {
        const secret = scrt ? scrt : localStorage.getItem('secret')
        const utm = utm_source ? utm_source : localStorage.getItem('utm_source')
        if (!secret && location.pathname !== '/login' && location.pathname !== '/') {
          setPageError('No secret is provided.')
          handleErrorOpen()
        }
        const result = await getPartnersDetails({ secret, utm })
        if (result && (!result.data || !result.status)) {
          setPageError('UTM not provided.')
          handleErrorOpen()
          return
        }
        if (result && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        }
        if (result && result.data && result.data.status === 'error') {
          setPageError(result.data.message)
          handleErrorOpen()
        } else if (result.error) {
          setPageError('Please check your internet or try again later.')
          handleErrorOpen()
        } else if (result && result.data && result.data.message === 'success') {
          if (result.data.secret) {
            const layout = result.data.layout
            setPartnerDetails(result.data)
            localStorage.setItem('secret', result.data.secret)
            localStorage.setItem('code', result.data.code)
            if (layout.body_color) document.documentElement.style.setProperty("--text-color", layout.body_color);
            if (layout.button_color) document.documentElement.style.setProperty("--primary-color", layout.button_color);
            if (layout.header_color) document.documentElement.style.setProperty("--secondary-color", layout.header_color);
            if (layout.redirect_url) {
              localStorage.setItem('partnerRedirect', layout.redirect_url)
            } else {
              localStorage.removeItem('partnerRedirect')
            }
          }
        }
      } catch (error) {
        setPageError('Something went wrong. Please try again later.')
        handleErrorOpen()
      }
    }
    getPartnerDetails()
  }, [getPartnersDetails, navigate, scrt, location, utm_source])

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname.toLowerCase() !== '/login') {
      const checked = localStorage.getItem('isChecked')
      if (checked) localStorage.removeItem('isChecked')
    }
  }, [location.pathname])

  /*useEffect(() => {
    const back = localStorage.getItem("backClicked")
    const lastVisitedPage = localStorage.getItem("lastVisitedPage");
    if (!back && lastVisitedPage && lastVisitedPage !== location.pathname) {
      navigate(lastVisitedPage);
    }
    if (back) {
      localStorage.setItem("lastVisitedPage", location.pathname)
      localStorage.removeItem("backClicked")
    }
  }, [navigate, location]);*/
  return (
    <>
      <CenteredPopup
        isOpen={isErrorModalOpen}
        buttons={errorModalButtons}
        onClose={handleErrorClose} icon={<WarningIcon />}>
        <p>{pageError}</p>
      </CenteredPopup>
      <header className="header">
        <div className='logo-box'>
          {/*back && <ArrowBack onClick={(e) => {
            e.preventDefault()
            localStorage.setItem('backClicked', true)
            setTimeout(() => {
              navigate(-1)
            }, 500);
          }} className='back-icon' />*/}
          {partnerDetails && partnerDetails.layout && partnerDetails.layout.logo ?
            <img src={partnerDetails.layout.logo} className='logo' alt={partnerDetails.layout.name} style={localStorage.getItem("utm_source") === "goodscore" ? {maxWidth: 60, minWidth: 60} : {}} />
            : null}
        </div>
        {cross && <div className='cross-icon' onClick={handleOpen}><CrossIcon /></div>}
      </header>
      <CenteredPopup
        isOpen={isModalOpen}
        buttons={modalButtons}
        onClose={handleClose} icon={<WarningIcon />}>
        <p>Are you want to sure cancel your loan application</p>
      </CenteredPopup>
    </>
  )
}

export default PageHeader